import { BaseControl } from "../base-control";

class RatingControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/rating-control/rating-control.component.html",
  controller: RatingControlCtrl
};